export enum EffectPanelEvent {
  'PANEL_SELECTED' = 'PANEL_SELECTED',
}
